import React from 'react';
import FirstStage from './FirstStage';
import Header from './Header';
import SecondStage from './SecondStage';
import ThankYou from './ThankYou';
import Preloader from './Preloader';
import Notice from './Notice';



import {sinksJson, tabletopsJson, initSinks, initTabletops, initDefaultConfig} from '../utils/vars';
import {stands, initStand} from '../utils/stands_id';
import {mirrors, initMirrors} from '../utils/mirrors_id';
import {cabinets, initCabinets} from '../utils/cabinets_id';
import {slider} from '../utils/img';
import {flaps, initFlaps} from '../utils/flaps/flaps';
import {initSinksId} from '../utils/sinks_id';

import {apiConstructor} from '../api/ConstructorApi';



//init
import {colorsTabletops, initStandColors, initColorsTabletops} from '../utils/colors';
import ModalPdf from './ModalVariable/ModalPdf';
import DocumentComponent from './PDFComponent';
import { pdf } from '@react-pdf/renderer';


//init functions


export default class App extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            //utils
            currentStage: 1,
            part: '',
            preloaderStatus: false,
            statusWindow: false,
            typeModalWindow: '',
            infoStands: "",
            renders: {},

            //src config
            sourceConfig: {},
            variableOptions: {
                positions: false,
                bicolor: false,
                cabinetsBicolor: false,
            },

            //current config
            config: {
                background: false,
                stand: false,
                sink: false,
                tabletop: false,
                mirror: false,
                cabinet: false,
            },

            //for pdf
            imgSrc: '',
            modalPdf: false,

            //Variable items
            variableSinks: [],
            variableTabletops: [],
            variableCabinets: [],

            //modalWindows
            sliderImgs: [],
            description: '',
        }

        this.canvasRef = React.createRef();
    }

    componentDidMount() {
        this._initTables();
    }

    async _initTables() {
        this.updatePreloader(true);
        const p1 = initColorsTabletops();
        const p2 = initFlaps();
        const p3 = initSinks();
        const p4 = initStandColors();
        const p5 = initStand();
        const p6 = initTabletops();
        const p7 = initDefaultConfig();
        const p8 = initMirrors();
        const p9 = initCabinets();
        const p10 = initSinksId();
        Promise.all([p1,p2,p3,p4,p5,p6,p7,p8,p9,p10]).then(res => {
            this.updatePreloader(false);
            this._checkGetParameters();
        })
    }


    async _checkGetParameters() {
        if(window.location.search !== '') {
            const urlParams = window.location.search.substring(1).split('&');
            const config = this._getParametersHandler(urlParams);
            await this.setConfiguration(config);
            this.changeCurrentStage(2);
        }
    }

    

    _getParametersHandler(urlParams) {
        const urlParamsFormat = urlParams.map(param => {
            return param.substring(param.indexOf('=') + 1);
        })
        const standParam = urlParamsFormat[0].split(',');
        const sinkParam = urlParamsFormat[1].split(',');
        const tabletopParam = urlParamsFormat[2].split(',');
        const mirrorParam = urlParamsFormat[3].split(',');
        const cabinetParam = urlParamsFormat[4].split(',');

        const config = {
            stand: standParam[0]!=='false' ? 
            {
                article: standParam[0],
                id: standParam[1],
                material: standParam[2],
                color: standParam[3],
                position: (standParam[4] === 'false' ? false : standParam[4])  || false,
                secondMaterial: (standParam[5] === 'false' ? false : standParam[5])  || false,
                secondColor: (standParam[6] === 'false' ? false : standParam[6])  || false,
            } : false,
            sink: sinkParam[0] !== 'false' ?
            {
                article: sinkParam[0],
                position: sinkParam[1],
                flap: sinkParam[2],
            }
            : false,
            tabletop: tabletopParam[0] !== 'false' ?
            {
                article: tabletopParam[0],
                color: tabletopParam[1] !== 'false' ? tabletopParam[1] : false,
                position: tabletopParam[2],
            }
            :
            false,
            mirror: mirrorParam[0] !== 'false' ?
            {
                article: mirrorParam[0],
                id: mirrorParam[1],
                material: mirrorParam[2] !== 'false' ? mirrorParam[2] : false ,
                color: mirrorParam[3] !== 'false' ? mirrorParam[3] : false,
            }
            :
            false,
            cabinet: cabinetParam[0] !== 'false' ? {
                article: cabinetParam[0],
                id: cabinetParam[1],
                material: cabinetParam[2],
                color: cabinetParam[3],
                position: cabinetParam[4],
                secondMaterial: cabinetParam[5],
                secondColor: cabinetParam[6],
            }
            :false
        }
        return config;
    }

    //Setters

    //Default configuration

    async setConfiguration(config) {
        const srcConfig = JSON.parse(JSON.stringify(config));
        const standConfig = await this._searchStand(config);
        let sinkConfig = false;
        let tabletopConfig = false;
        let mirrorConfig = false;
        let cabinetConfig = false;
        if(config.sink) {
            sinkConfig = {};
            const sink = this._searchSink(config.sink.article);
            sinkConfig.sink = sink.sink;
            sinkConfig.type = sink.type;
            sinkConfig.position = config.sink.position;
            sinkConfig.price = sink.sink[sink.type].price;
            sinkConfig.name = sink.sink.name;
            sinkConfig.article = config.sink.article;
            sinkConfig.fullArticle = config.sink.article;
            sinkConfig.cutout = config.sink.article.indexOf('W.') === -1 ? false : true;
            sinkConfig.flap = this._searchFlap(config.sink.flap);
        }
        if(config.tabletop) {
            tabletopConfig = {};
            const tabletop = this._searchTabletop(config.tabletop.article);
            const tabletopItem = this._searchTabletop(config.tabletop.article)[`${this._searchTypeTabletop(tabletop, tabletopConfig.color, config.tabletop.article)}`];
            const tabletopDepth = tabletopItem.codes.find(item => item.code === config.tabletop.article)
            tabletopConfig.depth = tabletopDepth.depth;
            tabletopConfig.height = this._searchTypeTabletop(tabletop, tabletopConfig.color, config.tabletop.article) === 'solid_surface_wide' ? 100 : this._searchTypeTabletop(tabletop, tabletopConfig.color, config.tabletop.article) === 'solid_surface_thin' ? 12 : 6;
            tabletopConfig.tabletop = tabletop;
            tabletopConfig.position = config.tabletop.position;
            tabletopConfig.countCup = config.tabletop.position === 'D' ? 2 : 1;
            tabletopConfig.color = config.tabletop.color;
            tabletopConfig.type = this._searchTypeTabletop(tabletop, tabletopConfig.color, config.tabletop.article);
            tabletopConfig.name = tabletop.name;
            tabletopConfig.price = tabletop[tabletopConfig.type].price;
            tabletopConfig.article = config.tabletop.article;
            tabletopConfig.fullArticle = config.tabletop.article.replace(/L\/R\/C\/D/, `${config.tabletop.position}`).replace(/XX-XX/, `${tabletopConfig.type === 'solid_surface_thin' || tabletopConfig.type==='solid_surface_wide' ? `SF-01` : `${config.tabletop.color}`}`)
        }

        if(config.mirror) {
            mirrorConfig = {}
            const mirror = await this._searchMirror(config.mirror.id, config.mirror.article, config);
            mirrorConfig.name = mirror.name;
            mirrorConfig.article = mirror.code;
            mirrorConfig.wMaterial = mirror.withMaterial;
            mirrorConfig.material = config.mirror.material;
            mirrorConfig.color = config.mirror.color;
            mirrorConfig.price = mirror.withMaterial ? mirror.material[mirrorConfig.material] : mirror.defaultPrice;
            mirrorConfig.mirror = mirror;
            mirrorConfig.fullArticle = mirror.code.replace(/XX-XX/, `${config.mirror.color}`).replace(/CH-XX/, `${config.mirror.color}`)
        }

        if(config.cabinet) {
            cabinetConfig = {}
            const cabinet = await this._searchCabinet(config.cabinet.id, config.cabinet.article, config);
            cabinetConfig.name = cabinet.name;
            cabinetConfig.cabinet = cabinet;
            cabinetConfig.material = config.cabinet.material;
            cabinetConfig.color = config.cabinet.color;
            cabinetConfig.name = cabinet.name;
            cabinetConfig.price = cabinet.material[config.cabinet.material].price;
            cabinetConfig.secondMaterial = config.cabinet.secondMaterial || false;
            cabinetConfig.secondColor = config.cabinet.secondColor || false;
            cabinetConfig.fullArticle = cabinet.code.replace(/XX.XX/, `${config.cabinet.color}`).replace(/L\\\R/, `${config.cabinet.position}`)
            cabinetConfig.position = config.cabinet.position;
        }

        let configuration = {
            stand: standConfig,
            sink: sinkConfig,
            tabletop: tabletopConfig,
            mirror: mirrorConfig,
            cabinet: cabinetConfig,
        }


        const variableSinks = this._searchVariableSinks(configuration.stand.stand.sinks);
        const variableTabletops = this._searchVariableTabletops(configuration.stand.stand.counterTops);
        const variableCabinets = this._searchVariableCabinents(configuration.stand.stand.name);
        this.setState(state => {
            return {
                sourceConfig: srcConfig,
                config: configuration,
                variableSinks: variableSinks,
                variableTabletops: variableTabletops,
                variableCabinets: variableCabinets,
            }
        })   
    }
    
    _initModalWindow(description, slider) {
        this.setState(state => {
            return {
                sliderImgs: slider,
                description: description
            }
        })
    }

    _searchStand(config) {
        this.updatePreloader(true);
        return new Promise((resolve, reject) => {
            const standConfig = {}
            apiConstructor.getStandsList(config.stand.id)
            .then(res => {
                let stand = res.data.find(stand => {
                    return stand.code === config.stand.article;
                });
                standConfig.stand = stand;
                standConfig.material = config.stand.material;
                standConfig.color = config.stand.color;
                standConfig.positionStand = config.stand.position || false;
                standConfig.secondMaterial = config.stand.secondMaterial || false;
                standConfig.secondColor = config.stand.secondColor || false;
                standConfig.name = stand.name;
                standConfig.fullArticle = stand.code.replace(/.XX.XX./, `.${config.stand.color}`).replace(/XX.XX./, `.${config.stand.secondColor}`);;
                standConfig.price = stand.material[config.stand.material].price;
                this.updatePreloader(false);
                resolve(standConfig)
            })
        })       
    }
    
    _searchSink(article) {
        let material;
        const sink = sinksJson.find(sink => {
            let currentSink = false;
            for(let key in sink) {
                if(sink[key].code) {
                    if(sink[key].code === article) {
                        currentSink = sink;
                        material = key;
                    }
                }
            }
            return currentSink;
        })
        return ({sink: sink, type: material})
    }

    _searchTypeTabletop(tabletop, color, article) {
        let currentType = '';
        if(!color) {
            for(let key in tabletop) {
                if(tabletop[key].codes) {
                    const type = key;
                    const codesArray = tabletop[key].codes;
                    for(let key in codesArray) {
                        if(codesArray[key].code === article) {
                            currentType = type;
                        }
                    }
                }
            }
        }
        else {
            for(let key in colorsTabletops) {
                const itemType = colorsTabletops[key].type[0]
                for(let key in itemType) {
                    const colorItem = itemType[key].colors
                    const material = key;
                    for(let i = 0; i<colorItem.length; i++) {
                        if(colorItem[i].color === color) {
                            currentType = material;
                        }
                    }
                }
                
            }
        }
        return currentType;
    }

    _searchTabletop(article) {
        const tabletop = tabletopsJson.find(tabletop => {
            let currentTabletop = false;
            for(let key in tabletop) {
                if(tabletop[key].codes) {
                    const codesArray = tabletop[key].codes;
                    for(let key in codesArray) {
                        
                        if(codesArray[key].code === article) {
                            currentTabletop = tabletop;
                        }
                    }
                }
            }
            return currentTabletop;
        })
        return tabletop;
    }

    _searchMirror(id, article, config) {
        return new Promise((resolve, reject) => {
            apiConstructor.getMirrorsList(config.mirror.id)
            .then(res => {
                const currentMirror = res.data.find(mirror => {
                    return mirror.code === article;
                })
                this.updatePreloader(false);
                resolve(currentMirror)
            })
        }) 
    }

    _searchCabinet(id, article, config) {
        return new Promise((resolve, reject) => {
            apiConstructor.getCabinetList(config.cabinet.id)
            .then(res => {
                const currentCabinet = res.data.find(mirror => {
                    return mirror.code === article;
                })
                this.updatePreloader(false);
                resolve(currentCabinet)
            })
        }) 
    }

    _searchSliderImgs(name) {
        let slider = [];
        stands.forEach(stand => {
            if(stand.name === name) {
                slider = stand.img;
            }
        })
        return slider;
    }

    _searchDescription(name) {
        let description = "";
        stands.forEach(stand => {
            if(stand.name === name) {
                description = stand.description;
            }
        })
        return description;
    }

    _setVariableOptions(value) {
        this.setState(state => {
            return {variableOptions: value}
        })
    }

    _searchFlap(article) {
        const currentFlap = flaps.filter(flap => {
            return flap.article === article;
        })
        return currentFlap[0] || false;
    }

    //add array sinks for card in second stage
    _searchVariableSinks(articleArray) {;
        const variableSinks = [];
        articleArray.forEach(article => {
            for(let key in sinksJson) {
                let sinkItem = sinksJson[key];
                for(let key in sinkItem) {
                    if(sinkItem[key].code && sinkItem[key].code === article) {
                        variableSinks.push(sinkItem);
                    }
                }
            }
        })
        return this._deleteDoublesArray(variableSinks);
    }

    //add array tabletops for card in second stage
    _searchVariableTabletops(articleArray) {
        const variablesTabletops = [];
        for(let key in tabletopsJson) {
            const tabletopItem = tabletopsJson[key];
            for(let key in tabletopItem) {
                const codes = tabletopItem[key].codes;
                if(codes) {
                    for(let key in codes) {
                        let check = false;
                        articleArray.forEach(article => {
                            if(article === codes[key].code){
                                check = true;
                            }
                        })
                        if(check) {
                            variablesTabletops.push(tabletopItem);
                        }
                    }
                }
                
            }
        }
        return this._deleteDoublesArray(variablesTabletops);
    }

    //add array cabinets for card in second stage
    _searchVariableCabinents(standName) {
        const filterCabinents = cabinets.filter(cabinet => {
            return standName.includes(cabinet.name.replace('Пенал ', '').replace('Penal', ''))
        })
        return filterCabinents;
    }

    //utils
    updatePreloader(value) {
        this.setState(state => {
            return {preloaderStatus: value}
        })
    }

    updateRenders(value) {
        this.setState(state => {
            return {renders: value}
        })
    }



    updateNoticeStatus(value) {
        this.setState(state => {
            return {
                statusNotice: value
            }
        })
    }

    changeCurrentStage(value) {
        this.setState(state => {
            return {currentStage: value}
        })
    }

    setStatusWindow(info) {
        this.setState({
            statusWindow: info.value,
            typeModalWindow: info.type,
        })
    }

    setStatusCheckout(value) {
        this.setState(state => {
            return {
                checkoutStatus: value,
            }
        })
    }

    updatePart(part) {
        this.setState(state => {
            return {
                part: part,
            }
        })
    }

    _deleteDoublesArray(array) {
        const removeDoublesArray = []
        array.forEach(sink => {
            let check = true;
            removeDoublesArray.forEach(sinkFilter => {
                if(JSON.stringify(sinkFilter) === JSON.stringify(sink)) {
                    check = false;
                }
                
            })
            if(check) {
                removeDoublesArray.push(sink);
            }
        })
        return removeDoublesArray
    }

    _modalPDFOpen() {
        document.querySelector('body').classList.add('hidden')
        this.setState(state => {
            return {
                modalPdf: true,
            }
        })
    }

    modalPDFClose() {
        document.querySelector('body').classList.remove('hidden')
        this.setState(state => {
            return {
                modalPdf: false,
            }
        })
    }

    setImageSrc(src) {
        this.setState(state => {
            return {
                imgSrc: src
            }
        })
    }

    generatePdfBase64 = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const doc = (<DocumentComponent 
                    canvasRef={this.canvasRef} 
                    config={this.state.config} 
                    imgSrc={this.state.imgSrc} 
                />);
                
                const asPdf = await pdf(doc).toBlob();
                const reader = new FileReader();
                
                reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                };
                
                reader.onerror = () => {
                    reject(new Error('Failed to convert PDF to base64'));
                };
                
                reader.readAsDataURL(asPdf);
            } catch (error) {
                reject(error);
            }
        });
    };


    render() {
        return (
            <div ref={this.constructorRef} className='constructor'>
                <Header 
                    config={this.state.config} 
                    modalPdf = {this.state.modalPdf}
                    modalPDFClose = {this.modalPDFClose.bind(this)}
                    renderConfig = {this.state.renders}
                    currentStage = {this.state.currentStage}
                    changeCurrentStage = {this.changeCurrentStage.bind(this)}
                    setStatusWindow = {this.setStatusWindow.bind(this)}
                /> 
                <div className='constructor__wrap'>
                    {/* <Ui></Ui> */}
                    {this.state.currentStage === 1 ? 
                        <FirstStage 
                            updatePreloader = {this.updatePreloader.bind(this)}
                            updateConfig = {this.setConfiguration.bind(this)} 
                            changeCurrentStage = {this.changeCurrentStage.bind(this)}>
                        </FirstStage>
                        :
                        ''
                    }
                    {this.state.currentStage === 2 ? 
                        <SecondStage 
                            config = {this.state.config}
                            srcConfig = {this.state.sourceConfig}
                            setConfiguration = {this.setConfiguration.bind(this)}
                            variableOptions = {this.state.variableOptions}
                            //parts
                            part = {this.state.part}
                            updatePart = {this.updatePart.bind(this)}
                            //utils
                            updatePreloader = {this.updatePreloader.bind(this)}
                            updateNoticeStatus = {this.updateNoticeStatus.bind(this)}
                            setStatusWindow = {this.setStatusWindow.bind(this)}
                            setStatusCheckout = {this.setStatusCheckout.bind(this)}
                            changeCurrentStage = {this.changeCurrentStage.bind(this)}
                            updateRenders = {this.updateRenders.bind(this)}
                            statusModalWindow = {this.state.statusWindow}
                            typeModalWindow = {this.state.typeModalWindow}
                            sliderImgs = {this.state.sliderImgs}
                            description = {this.state.description}
                            setVariableOptions = {this._setVariableOptions.bind(this)}
                            
                            initModal = {this._initModalWindow.bind(this)}
                            imgSrc={this.state.imgSrc}
                            
                                

                            //forPDF
                            setImageSrc = {this.setImageSrc.bind(this)}
                            canvasRef={this.canvasRef}
                            openModal={this._modalPDFOpen.bind(this)}

                            //variables parts
                            variableSinks = {this.state.variableSinks}
                            variableTabletops = {this.state.variableTabletops}
                            variableCabinets = {this.state.variableCabinets}

                            //pdf
                            generatePdf = {this.generatePdfBase64}
                        >
                        </SecondStage>
                        :
                        ''
                    }
                    {this.state.currentStage === 3 ? 
                        <ThankYou
                            status = {this.state.checkoutStatus}
                            updatePart = {this.updatePart.bind(this)}
                            changeCurrentStage = {this.changeCurrentStage.bind(this)}
                        />
                        :
                        ''
                    }
                </div>

                <Notice updateNoticeStatus = {this.updateNoticeStatus.bind(this)} status={this.state.statusNotice}/>
                <ModalPdf canvasRef={this.canvasRef}  config={this.state.config} status = {this.state.modalPdf} imgSrc={this.state.imgSrc}></ModalPdf>
                <Preloader status = {this.state.preloaderStatus}/>
                <canvas className='pdf-canvas' width="800px" height="800px" ref={this.canvasRef}></canvas>
            </div>
        );
    }
}